import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { StoreLikeRequestBody, StoreLikeResponse } from "./types";

export class StoreLikeAPI extends BaseAPI<
  StoreLikeRequestBody,
  StoreLikeResponse
> {
  protected route = ApiRoutes.store.like;
  protected method = RequestMethod.PUT;
}
